import Vue from "vue";
import axios from "axios";
import qs from "qs";
import crypto from "crypto";
import store from "@/store";
import Router from "@/router/index";
import Fingerprint2 from 'fingerprintjs2'

Vue.prototype.axios = axios;
//http://market.api.fgcq.info/
//https://jyhinterface.juhero.cn/
// var origin = "";
// if (window.origin == "https://market.fgcq.info" || window.origin == 'http://qnjyh.fgcq.info' || window.origin == 'http://xjjyh.fgcq.info' || window.origin == 'http://hljyh.fgcq.info') {
//   origin = "https://market-api.fgcq.info/";
// } else {
//   origin = "https://jyhinterface.juhero.cn/";
// }

const baseURL = axios.defaults.baseURL = process.env.VUE_APP_BASE_API
// const baseURL = axios.defaults.baseURL = 'https://jyhinterface.juhero.cn/'

const instance = axios.create({
  baseURL,
  timeout: 30000,
  withCredentials: false,
  headers: {
    Accept: "application/json, text/plain, */*",
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
    Pragma: 'no-cache',
    'Cache-Control': 'no-cache'
  },
  transformRequest: data => qs.stringify(data),
});

const allowDuringAutoLogin = new Set([
  'user-info/get-box-userinfo',
  'user-info/login-by-39box',
  'game/app-list',
])

function waitAutoLoginEnd(timeoutMs = 15000) {
  if (!store.state.isAutoLogin) return Promise.resolve()
  return new Promise((resolve) => {
    const start = Date.now()
    const timer = setInterval(() => {
      if (!store.state.isAutoLogin || Date.now() - start >= timeoutMs) {
        clearInterval(timer)
        resolve()
      }
    }, 50)
  })
}

instance.interceptors.request.use(
  async (config) => {
    if (store.state.isAutoLogin && !allowDuringAutoLogin.has(config.url)) {
      await waitAutoLoginEnd()
    }
    return config
  },
  (error) => Promise.reject(error)
)

// 添加响应拦截器
instance.interceptors.response.use(
  response => {
    if (response.headers["date"]) {
      store.commit("setServiceTime", response.headers.date);
    }
    if (response.status == 200) {
      const data = response.data || {};
      // if(data.code != 200 && data.msg) {
      //   store.dispatch('pushError', data.msg)
      // }
      const excludeLogoutRoutes = [
        'user.goods', 
        'user.sell', 
        'user.buy', 
        'user.center', 
        'sell', 
        'acc.goods',
        'user.msg'
      ];
      const currentRouteName = Router.currentRoute ? Router.currentRoute.name : '';
      if (data.code == 401) {
        if (!store.state.isAutoLogin && !excludeLogoutRoutes.includes(currentRouteName)) {
          store.dispatch("logout", "replace");
        }
      }  
      if (data.code != 200 && data.msg) {
        if(response.config.url != 'user-info/user-role-list'&&response.config.url != 'goods/backpack'&&response.config.url != 'goods/on-sale'&&(response.config.url != 'user-info/bind-account' && data.code != '203')&&response.config.url != 'user-info/certify-query'&&(response.config.url != 'login-out/check-login-out' && data.code != '407') && response.config.url != 'goods-role/cp-rolelist' && response.config.url != 'goods-role/index-by-key' && (response.config.url != 'user-info/login') && response.config.url != 'user-info/send-code' && response.config.url != 'pay-password/send-code' && response.config.url != 'goods-role/down') {
          if(!store.state.isAutoLogin && !excludeLogoutRoutes.includes(currentRouteName)) {
            store.dispatch("pushError", data.msg);
          }
        }
      }
      if (data.missionMsg) {
        Message.info({
          render: h =>
            h("div", {
              domProps: { innerHTML: data.missionMsg },
            }),
        });
        alert(data.missionMsg);
      }
      return data;
    }
    return {};
  },
  error => {
    store.dispatch("pushError", error.toString());
    return Promise.resolve(error);
  }
);

function uuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}

const MD5 = value => {
  return crypto.createHash("md5").update(value).digest("hex");
};
//encodeURIComponent(key)
const sign = (params = {}) => {
  const keys = Object.keys(params).sort();
  const signs = [];
  for (let key of keys) {
    if (params[key] == null) continue;
    signs.push(key + '=' + params[key]);
  }
  // signs.push(`AfkRZKZs2LxuscnNUbpQrWppJvx48GEg`);
  //console.log(signs.join("&") + 'AfkRZKZs2LxuscnNUbpQrWppJvx48GEg');
  return MD5(signs.join("&") + 'AfkRZKZs2LxuscnNUbpQrWppJvx48GEg');
};

async function getUdid() {
  const fp = await new Promise((resolve) => {
    Fingerprint2.get(function(components) {
      const values = components.map((component,index) =>
      {
       if (index === 0) { //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
         return component.value.replace(/\bNetType\/\w+\b/, '')
       }
       return component.value
      }
      )
      // 生成最终id murmur 
      // console.log(values,'使用的浏览器信息')  //使用的浏览器信息
      const udid = Fingerprint2.x64hash128(values.join(''), 31)
      // console.log(udid,'生成的标识码') //生成的标识码
      resolve(udid);
    })
  })
  return fp;
}

const Ajax = async (url, data = {}, method = "post", conf = {}) => {
  let access_token;
  let refresh_token;
  let rs;
  const { auth = true } = conf;
  if (auth) {
    ({ access_token, refresh_token } = store.getters.state);
    if (refresh_token && !access_token) {
      access_token = await store.dispatch("refreshToken", refresh_token);
    }
  }

  if (access_token) {
    conf.headers = {
      Authorization: access_token,
      ...(conf.headers || {}),
    };
  }
    instance.defaults.headers.common["Authorization"] = access_token;
    var params = {
      udid: await getUdid()
    };
    if (access_token != "") {
      var timestamp = Date.parse(new Date()) / 1000;
      var uuids = uuid();
      const request_id = MD5(access_token + uuids + timestamp);
      params["request_id"] = request_id;
      params["timestamp"] = timestamp;
    }
    if (method == "get") {
      rs = await instance({
        url,
        method,
        params: {
          ...data,
          ...params,
          sign: sign({ ...data, ...params })
        },
        ...conf,
      });
    } else {
      if(url == 'wallet/upload-img') {
        var fd = new FormData();
        fd.append("file", data.file);
        fd.append("request_id",params.request_id)
        fd.append("timestamp",params.timestamp)
        rs = await instance({
          url,
          method,
          data: {
            ...fd,
          },
          ...conf,
          
        });
      }else {
        rs = await instance({
          url,
          method,
          data: {
            ...data,
            ...params,
            sign: sign({ ...data, ...params }),
          },
          ...conf,
        });
      }
    }
  return rs;
};
const httpRequest = async(url,file) => {
  let access_token;
  let refresh_token;
    ({ access_token, refresh_token } = store.getters.state);
    if (refresh_token && !access_token) {
      access_token = await store.dispatch("refreshToken", refresh_token);
    }
    const headers = {
      'Authorization': access_token,
      'Refresh-Token': refresh_token,
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
      Pragma: 'no-cache',
      'Cache-Control': 'no-cache'
    }
    var params = {};
    if (access_token != "") {
      var timestamp = Date.parse(new Date()) / 1000;
      var uuids = uuid();
      const request_id = MD5(access_token + uuids + timestamp);
      params["request_id"] = request_id;
      params["timestamp"] = timestamp;
    }
    const fd = new FormData();
    fd.append("file", file);
    fd.append("request_id",params.request_id)
    fd.append("timestamp",params.timestamp)
    // fd.append('sign',sign({...file,...params}))
    return axios.post(baseURL + url, fd,{ headers })
};

export { baseURL, Ajax, MD5, httpRequest };
export default Ajax;
